import React from 'react'
import SelectBase from 'react-select';
import { StyledSelectWrapper, StyledLabel } from './styles';

interface OptionType {
  value: string | number;
  label: string;
}

interface Props {
  options: OptionType[];
  value?: OptionType | null;
  placeholder?: string;
  label?: string;
  onChange: (option: OptionType | null) => void;
  className?: string; 
  $hasError?: boolean;
}

export const Select: React.FC<Props> = ({ onChange, $hasError, ...props }) => {
  return (
    <StyledSelectWrapper $hasError={$hasError}>
      {props.label && <StyledLabel>{props.label}:</StyledLabel>}
      <SelectBase<OptionType, false>
        {...props}
        className='styled__react-select'
        placeholder={props.placeholder || 'Vyberte...'}
        onChange={option => onChange(option as OptionType | null)}
        isClearable
      />
    </StyledSelectWrapper>
  );
}